import { ModalErrorConfig } from '@core/interfaces/modal-error-config.interface';
import { PROJECT_TYPE } from '@core/types/projects.type';

export const PROJECT_NAME_BY_TYPE = new Map<PROJECT_TYPE, string>([
  ['ACC', 'mf-steps'],
  ['PLD', 'mf-loan'],
  ['FTD', 'mf-ftd'],
]);

export const IDLE_TIMEOUT_CONFIG = new Map<PROJECT_TYPE, ModalErrorConfig>([
  [
    'ACC',
    {
      imageUrl: {
        url: 'assets/img/errors/error__idle-timeout.svg',
        altUrl: 'Information for idle-timeout icon/illustration',
      },
      errorTitle: '¿Sigues ahí?',
      errorDescription:
        'Ya casi terminas de abrir tu nueva cuenta digital. Te daremos unos minutos para retomar.',
      buttonLabel: 'He vuelto',
    },
  ],
  [
    'PLD',
    {
      imageUrl: {
        url: 'assets/img/errors/error__idle-timeout.svg',
        altUrl: 'Information for idle-timeout icon/illustration',
      },
      errorTitle: '¿Sigues ahí?',
      errorDescription: '¡Ya casi tienes tu préstamo! Te daremos unos minutos para retomar.',
      buttonLabel: 'He vuelto',
    },
  ],
  [
    'FTD',
    {
      imageUrl: {
        url: 'assets/img/errors/error__idle-timeout.svg',
        altUrl: 'Information for idle-timeout icon/illustration',
      },
      errorTitle: '¿Sigues ahí?',
      errorDescription:
        'Ya casi terminas de abrir tu depósito a plazo fijo. Te daremos unos minutos para retomar.',
      buttonLabel: 'He vuelto',
    },
  ],
  [
    'ENROLLMENT',
    {
      imageUrl: {
        url: 'assets/img/errors/error__idle-timeout.svg',
        altUrl: 'Information for idle-timeout icon/illustration',
      },
      errorTitle: '¿Sigues ahí?',
      errorDescription: 'Ya casi terminas crear tu usuario. Te daremos unos minutos para retomar.',
      buttonLabel: 'He vuelto',
    },
  ],
]);
